import { TerminalService } from 'src/app/services/terminal.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PwaTerminalGuard  {
  constructor(
    private terminalService: TerminalService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
      return from(this.terminalService.isPWATerminal()).pipe(
        take(1),
        map(isPWA => isPWA),
        tap(result => {
          if (result) {
            return of(true);
          } else {
            this.router.navigate(['/home/login'], {relativeTo: this.route });
            return of(false);
          }
        })
      );
  }
}
